import request from "../request";

export const getAllLearningContinuum = (curriculumId, drId, lcId) =>
  request
    .get(
      `/assessment/${curriculumId}/developmental-rubrics/${drId}/learning-continuum/${lcId}/granular-steps`
    )
    .then((res) => res);

export const insertLearningContinuum = (curriculumId, drId, data) =>
  request
    .post(
      `/assessment/${curriculumId}/developmental-rubrics/${drId}/learning-continuum/insert`,
      data
    )
    .then((res) => res);

export const removeLearningContinuum = (curriculumId, drId, data) =>
  request
    .post(
      `/assessment/${curriculumId}/developmental-rubrics/${drId}/learning-continuum/remove`,
      data
    )
    .then((res) => res);